// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DesktopUserPanel_wrapper__28Fv4","item":"DesktopUserPanel_item__2olU0","section":"DesktopUserPanel_section__3DqPv"};